module.exports = __webpack_public_path__ + "static/img/success.4f0579d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download/success.png
// module id = /VKq
// module chunks = 1